var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.actionButton ? _c('button', {
    staticClass: "offer-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openDebtTypePicker();
      }
    }
  }, [_vm._v(" Výpočet ")]) : _c('div', {
    staticClass: "text-cta pointer",
    on: {
      "click": function click($event) {
        return _vm.openDebtTypePicker();
      }
    }
  }, [_vm._v(" Výpočet ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }